import { render, staticRenderFns } from "./MainProject.vue?vue&type=template&id=4aa9a3b8&scoped=true&"
import script from "./MainProject.vue?vue&type=script&lang=js&"
export * from "./MainProject.vue?vue&type=script&lang=js&"
import style0 from "./MainProject.vue?vue&type=style&index=0&id=4aa9a3b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa9a3b8",
  null
  
)

export default component.exports